export default __webpack_public_path__ + "static/media/baby_square.366c69dd.jpg";